export function Training() {
  return (
    <div className="page">
      <section className="content-section">
        <h1>Training Programs</h1>
        <p>Enable your team with practical technology skills, product practices, and growth engineering mindsets.</p>

        <div className="services-list">
          <div className="service-item">
            <h3>📚 Technical Bootcamps</h3>
            <p>Hands-on bootcamps covering frontend, backend, cloud, and mobile development.</p>
          </div>

          <div className="service-item">
            <h3>👥 Team Workshops</h3>
            <p>Customized sessions for engineering teams, product teams, and leadership alignment.</p>
          </div>

          <div className="service-item">
            <h3>🎯 Product & Agile Coaching</h3>
            <p>Coaching for better product discovery, delivery processes, and team collaboration.</p>
          </div>

          <div className="service-item">
            <h3>💡 Startup Enablement</h3>
            <p>Training programs focused on rapid prototyping, MVP delivery, and scaling product teams.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
